import React from "react";
import styled, { css } from "styled-components";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import Languages from "./Languages";
import Header from "./Header";
import Contributors from "./Contributor";
import SEO from "../SEO";

class SideInfo extends React.Component {
    state = {
        generalData: null
    }

    handleClose = () => {
        this.props.handleClose();
    }

    shouldComponentUpdate(nextProps) {
        const { isDisplayed, country, contributions, displayLeft, mode } = nextProps;
        // Only update if the above props changed
        if (isDisplayed === this.props.isDisplayed
            && country === this.props.country
            && contributions === this.props.contributions
            && displayLeft === this.props.displayLeft
            && mode === this.props.mode) {
                return false;
            } else {
                return true;
            }
    }

    render() {
        console.log(this.props.country);
        return <Container 
                mode={ this.props.mode }
                isDisplayed={ this.props.isDisplayed } 
                displayLeft={ this.props.displayLeft }>
            { this.props.country && <SEO 
                title={`${ this.props.country.toUpperCase() } | Top contributors`}
            />  }
            <Router>
                <Header 
                    contributions={ this.props.contributions }
                    country={ this.props.country } 
                    handleClose={ this.handleClose }
                    currentIso={ this.props.currentIso }
                    mode={ this.props.mode } />
                <Redirect from="/" to="/" />
                <Route path="/" exact component={ ({ history }) => <Languages 
                    history={ history } 
                    mode={ this.props.mode }
                    country={ this.props.country } /> } />
                <Route path="/contributors" component={ ({ history }) => <Contributors 
                    mode={ this.props.mode } 
                    history={ history }
                    country={ this.props.country } /> } />
            </Router>
        </Container>
    }
}

const Container = styled.div`
    width: 350px;
    height: 100vh;
    position: absolute;
    top: 0%;
    z-index: 1000;
    padding: 12px;
    transition: 0.4s all ease;
   
    ${ props => props.mode === "dark"
        ? css`background: #191919eb;`
        : css`background: #f3f3f3eb;` }

    ${ props => props.displayLeft 
        ? css`left: 0;`
        : css`right: 0;` }


    ${ props => {
        if (!props.isDisplayed) {
            return props.displayLeft
                ?  css`
                    visibility: hidden;
                    left: -350px;
                    /* width: 0;  */
                `
                : css`
                    visibility: hidden;
                    right: -350px;
                `
            }
        }
    }
`

export default SideInfo;